{
  "version": 1,
  "asset_id": "c7e5f48c-b470-4241-ab33-bf61551592c9",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/c7e5f48c-b470-4241-ab33-bf61551592c9/hero-irs-building.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/c7e5f48c-b470-4241-ab33-bf61551592c9/hero-irs-building.jpg",
  "original_filename": "hero-irs-building.jpg",
  "size": 251503,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:02Z"
}
